










































































































































































import {Component, Vue} from 'vue-property-decorator';
import {User} from '@/oauth/User';
import {Validation} from '@/utils/Validation';
import {getModule} from 'vuex-module-decorators';
import {CustomerStore} from '@/store/CustomerStore';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {UserDto} from '@/oauth/UserDto';
import {AuthorityDto} from '@/oauth/AuthorityDto';
import {AuthTokenDto, CodeResp} from '@/oauth/AuthTokenDto';
import CodeSlider from '@/components/CodeSlider.vue';
import Header from "@/views/KeShangAdmin/Header.vue";
import XHeader from "@/views/KeShangAdmin/XHeader.vue";
import Footer from "@/views/KeShangAdmin/Footer.vue";
import {OpenfireDto} from "@/dto/OpenfireDto";
import { CustomerDto } from '@/dto/CustomerDto';
import {Openfire} from "@/entity/Openfire";

@Component({
  components: {Footer, XHeader, Header, CodeSlider},
})
export default class ZiZhangHao extends Vue {
  user = new User();
  v = Validation;
  cs = getModule(CustomerStore);
  su = SecurityUtils;
  codeResp = new CodeResp();
  private users: User[] = [];
  public rows: User[] = [];
  public dialogFlage = false
  userFinder = new User()

  deleteZiZhangHao = false

  openDialog(){
    this.dialogFlage = true
  }
  public  temporaryUser = new User()
  openDeleteDialog(CDUser: User){
    this.deleteZiZhangHao = true
    this.temporaryUser = CDUser
  }

  fanghui() {
    this.$router.push("/keShangSelect")
  }


  private dateFormat(time: number) {
   const date=new Date(time);
   const year=date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
   const month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
   const day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
   const hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
   const minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
   const seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
  // 拼接
  return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
}



  async findAll() {
    const users = await UserDto.findAllByAuthority(this.cs.currentCustomer.toRole());
    this.users = users.filter(value => value.id !== this.su.getLoginUser().id);

    this.rows = this.users;

    // console.log(this.rows)
  }

  async add() {
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      const user = await UserDto.findByUsername(this.user.username);
      if (user.username === '') {
        // user = await this.createUser(user);
        // console.log(user)
        // this.$q.notify('用户不存在')
      }
      const role = this.cs.currentCustomer.toRole();
      const authority = await AuthorityDto.findByAuthority(role);
      user.addAuthority(authority);
      const openfire = new Openfire();
      openfire.userName = user.username;
      openfire.customerName = this.cs.currentCustomer.name;
      await OpenfireDto.addZiZhangHao(openfire);
      await UserDto.save(user);
      this.dialogFlage = false
      this.findAll();
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {nf({type: 'negative', message: '错误:' + '用户已存在或者用户不存在，请先注册', timeout: 2500});
    }


  }

  private createUser(user: User): Promise<User> {
    return new Promise((resolve, reject) => {
      const model = '';
      this.$q.dialog({title: '为新用户指定密码', persistent: true, prompt: {model: model}}).onOk(async (s: string) => {
        user.username = this.user.username;
        user.password = s;
        // user.code = this.user.code
        // user.receiver = this.user.username
        await AuthTokenDto.getTokenByRegister(user, this.codeResp);
        const u = await UserDto.findByUsername(user.username);
        resolve(u);
      }).onCancel(reject);
    });
  }


  async deleteRole(u: User) {
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      u.authorities = u.authorities.filter(value => {
        return !value.authority.startsWith(this.cs.currentCustomer.toRole());
      });
      const openfire = new Openfire();
      openfire.userName = u.username;
      openfire.customerName = this.cs.currentCustomer.name;
      await OpenfireDto.deleteZiZhangHao(openfire);
      await UserDto.save(u);
      await this.findAll();
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {
      nf({type: 'negative', message: '错误:' + e, timeout: 2500});
    }
this.deleteZiZhangHao = false
  }

  public get columns() {
    let columns = User.getColmuns();
    columns.push({
      label: '编辑',
      name: 'edit',
      field: '',
    });
    columns = columns.filter(value => !['creatorId', 'isReviewPass'].some(s => value.name === s));
    return columns;
  }

  private mounted() {
    if (typeof this.cs.currentCustomer.id === 'undefined') {
      this.$router.replace({name: 'KeShangSelect'});
      return;
    }
    if (!this.su.getLoginUser().hasAnyRole('ADMIN', this.cs.currentCustomer.toRole('ADMIN'))) {
      this.$q.notify('你没有权限使用此组件');
      this.$router.replace({name: 'Home'});
    }
    this.findAll();
    return;
  }
}
